/* global rp$, window, document */
'use strict';

const { handleGarageData } = require('public/js/components/garage-store.js');

const runScriptOnReady = require('public/js/lib/run-script-on-ready');
const utils = require('public/js/helpers/utils');

function attachEvents() {
	if (!handleGarageData || typeof handleGarageData.getGarageData !== 'function') {
		return;
	}

	rp$(document)
		.off('garageUpdated.vehicleDropDowns')
		.on('garageUpdated.vehicleDropDowns', handleGarageUpdated);

	const vehicleDropDownsComponent = document.querySelector('.vehicle-drop-down-component');
	const isVehicleSpecificPage = utils.isTruthyDataValue(vehicleDropDownsComponent?.dataset?.isVehicleSpecificPage);
	const garage = handleGarageData.getGarageData(isVehicleSpecificPage);
	if (garage) {
		handleGarageUpdated(garage);
	}
}

function handleGarageUpdated(eventOrGarage, maybeGarage, ...rest) {
	const garage = utils.normalizeEventPayloadArgs(eventOrGarage, maybeGarage, rest);
	if (garage.length === 0) {
		return;
	}

	const selectedCar = garage.find((car) => car?.selected) || null;
	const wrappers = document.querySelectorAll('.vehicle-drop-down-component .vehiclepicker_wrapper');
	if (!wrappers || wrappers.length === 0) {
		return;
	}

	const getBrowseCatalogSuffix = (wrapper) => {
		return wrapper?.dataset?.browseSuffix ?? '';
	};

	const syncVehiclePickerLink = (element, isDefaultAction, options = {}) => {
		if (!element) {
			return;
		}

		const {
			tabindex = true,
			disableClass = true,
		} = options;

		if (disableClass) {
			element.classList.toggle('disabled', isDefaultAction);
		}
		if (tabindex) {
			isDefaultAction ? element.setAttribute('tabindex', '-1') : element.removeAttribute('tabindex');
		}
	};

	const setVisible = (element, visible) => {
		if (!element) return;
		element.style.display = visible ? '' : 'none';
	};

	const validateString = (value) => {
		return typeof value === 'string' && value !== '';
	};

	const setTextIfValid = (element, isValid, text) => {
		if (!element || !isValid) {
			return;
		}
		element.textContent = text;
	};

	const setDefaultAction = (element, isDefaultAction, defaultRedirectUri) => {
		if (!element || !isDefaultAction) {
			return;
		}
		element.classList.add('vehiclepicker_link');
		element.dataset.redirect = defaultRedirectUri;
	};

	wrappers.forEach((wrapper) => {
		const selectedVehicleHeader = wrapper.querySelector('.selected-vehicle-header');
		const getStepButtonItem = (step) => wrapper.querySelector(`ul.vpicker_buttons > li.vpicker_button[data-vehicle-dropdown-button="${step}"]`);
		const yearButtonItem = getStepButtonItem('year');
		const makeButtonItem = getStepButtonItem('make');
		const modelButtonItem = getStepButtonItem('model');
		const trimButtonItem = getStepButtonItem('trim');
		const engineButtonItem = getStepButtonItem('engine');

		const placeholderTrim = wrapper.dataset.placeholderTrim;
		const placeholderEngine = wrapper.dataset.placeholderEngine;
		const defaultAction = wrapper.dataset.defaultAction;
		const defaultRedirectUri = wrapper.dataset.defaultRedirectUri;

		const trimConfiguredInitially = Boolean(trimButtonItem && trimButtonItem.style.display !== 'none');
		const engineConfiguredInitially = Boolean(engineButtonItem && engineButtonItem.style.display !== 'none');

		const browseLink = wrapper.querySelector('a[data-vehicle-dropdown-data="browse-catalog"]');
		const selectLink = wrapper.querySelector('a.js-vpicker-select-vehicle');
		const changeLinks = wrapper.querySelectorAll('a[data-vehicle-dropdown-data="change-vehicle"]');

		if (!selectedCar) {
			return;
		}

		const yearUi = utils.getNumberString(selectedCar.ui_year || selectedCar.year);
		const makeUi = utils.getNonEmptyString(selectedCar.ui_make || selectedCar.make);
		const modelUi = utils.getNonEmptyString(selectedCar.ui_model || selectedCar.model);
		const trimUi = utils.getNonEmptyString(selectedCar.ui_trim || selectedCar.trim);
		const engineUi = utils.getNonEmptyString(selectedCar.ui_engine || selectedCar.engine);

		// Year
		const isValidYearUi = validateString(yearUi);
		if (yearButtonItem) {
			const yearText = yearButtonItem.querySelector('.vpicker-select');
			setTextIfValid(yearText, isValidYearUi, yearUi);
		}

		// Make
		const isValidMakeUi = validateString(makeUi);
		if (makeButtonItem) {
			makeButtonItem.classList.toggle('active_button', isValidMakeUi);
			const makeText = makeButtonItem.querySelector('.vpicker-select');
			setTextIfValid(makeText, isValidMakeUi, makeUi);
			const makeAnchor = makeButtonItem.querySelector('a');
			syncVehiclePickerLink(makeAnchor, !isValidYearUi);
			setDefaultAction(makeAnchor, defaultAction, defaultRedirectUri);
		}

		// Model
		const isValidModelUi = validateString(modelUi);
		if (modelButtonItem) {
			modelButtonItem.classList.toggle('active_button', isValidModelUi);
			const modelText = modelButtonItem.querySelector('.vpicker-select');
			setTextIfValid(modelText, isValidModelUi, modelUi);
			const modelAnchor = modelButtonItem.querySelector('a');
			syncVehiclePickerLink(modelAnchor, !isValidMakeUi);
			setDefaultAction(modelAnchor, defaultAction, defaultRedirectUri);
		}

		// Trim (optional)
		const isValidTrimUi = validateString(trimUi);
		if (trimButtonItem && placeholderTrim !== '' && placeholderTrim !== null) {
			setVisible(trimButtonItem, trimConfiguredInitially || isValidTrimUi);
			trimButtonItem.classList.toggle('active_button', isValidMakeUi);
			const trimText = trimButtonItem.querySelector('.vpicker-select');
			setTextIfValid(trimText, isValidTrimUi, trimUi);
			const trimAnchor = trimButtonItem.querySelector('a');
			syncVehiclePickerLink(trimAnchor, !isValidModelUi);
			setDefaultAction(trimAnchor, defaultAction, defaultRedirectUri);
		}

		// Engine (optional)
		const isValidEngineUi = validateString(engineUi);
		if (engineButtonItem && placeholderEngine !== '' && placeholderEngine !== null) {
			setVisible(engineButtonItem, engineConfiguredInitially || isValidEngineUi);
			engineButtonItem.classList.toggle('active_button', isValidEngineUi);
			const engineText = engineButtonItem.querySelector('.vpicker-select');
			setTextIfValid(engineText, isValidEngineUi, engineUi);
			const engineDisabled = trimButtonItem ? !isValidTrimUi : !isValidModelUi;
			const engineAnchor = engineButtonItem.querySelector('a');
			syncVehiclePickerLink(engineAnchor, engineDisabled);
			setDefaultAction(engineAnchor, defaultAction, defaultRedirectUri);
		}

		// Browse Catalog
		const basePath = utils.buildVehicleBasePath(selectedCar);
		if (browseLink && basePath) {
			browseLink.href = basePath + getBrowseCatalogSuffix(wrapper);
		}
		setVisible(browseLink, Boolean(basePath) && isValidYearUi);
		setVisible(selectLink, !isValidYearUi);
		
		// Change Vehicle
		changeLinks.forEach((anchor) => 
			setVisible(anchor, isValidYearUi && (
				anchor.dataset.vehicleDropdownShow === 'true' || 
				anchor.dataset.vehicleDropdownShow === true || 
				anchor.dataset.vehicleDropdownShow === '1' || 
				anchor.dataset.vehicleDropdownShow === 1
			)));
		
		// Box Title
		if (selectedVehicleHeader) {
			const withVehicleTitle = selectedVehicleHeader.dataset.vehicleDropdownTitleWithVehicle || '';
			setTextIfValid(selectedVehicleHeader, isValidYearUi && withVehicleTitle !== '', withVehicleTitle);
		}
	});
}

runScriptOnReady('vehicle_drop_downs_component', attachEvents);

